import { render, staticRenderFns } from "./training-view-page.vue?vue&type=template&id=3cda8bc2&"
import script from "./training-view-page.vue?vue&type=script&lang=js&"
export * from "./training-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports